export const getFlatsByGridData = (data = []) => {
  if (!data || data?.length === 0) return [];

  return data.flatMap((item) => item.flats);
};
